import request from '@/utils/request'

// 获取渠道id
// export function indexInfo(params) {
//   return request({
//     // url: '//192.168.26.179:6601/api/v1/oem/webSite/domainChannel',
//     url: '//sysapi.jxhh.com/api/v1/oem/webSite/domainChannel',
//     method: 'get',
//     params
//   })
// }
export function indexInfo (params) {
  return request({
    url: 'app/domainChannel',
    method: 'get',
    params
  })
}
// 获取全部域名
export function getdomain(params) {
  return request({
    // url: '//192.168.26.179:6601/api/v1/oem/channel/domainFront',
    url: 'app/channel/domainFront',
    method: 'get',
    params

  })
  // return request({
  //   // url: '//192.168.26.179:6601/api/v1/oem/channel/domainFront',
  //   url: '//sysapi.jxhh.com/api/v1/oem/channel/domainFront',
  //   method: 'get',
  //   params

  // })
}
export function webSite(params) {
  return request({
    url: '/oem/webSite',
    method: 'get',
    params
  })
}

// 获取logo
export function backDetailsView(data) {
  return request({
    url: '/channelSite/info',
    method: 'post',
    data
  })
}
// 开放平台所有列表
export function OpenList (data){
  return request({
    url: '/app/front/openList',
    method: 'get',
    params: data
  })
}

// 通用设置所有列表
export function Counsel (data){
  return request({
    // url:'//192.168.26.179:6601/api/v1/oem/common/counsel',
    url:'/channelSite/domain/info',
    method:'post',
    data
  })
}
